let calendarInit = function () { }

let searchInit = function () {
    $(".js-search-open").on('click', function(event){
        event.preventDefault();
        $('body.blurring').dimmer('show');
    });
    $(".js-search-close").on('click', function(event){
        event.preventDefault();
        $('body.blurring').dimmer('hide');
        $(".js-search-results *").remove();
    });
}

let pad = function (num, size) {
  var s = num+"";
  while (s.length < size) s = "0" + s;
      return s;
}

let initCalendar = function () {
    $('#archiveLink').calendar({
        type: 'date',
        onChange: function (date, text, mode) {
            console.log('onChange', date, text, mode);
            date = new Date(date);
            let month = (date.getMonth() + 1).toString(),
                year = (date.getFullYear()).toString(),
                day = (pad(date.getDate(), 2)).toString();
            month = (month.length < 2) ? '0'+month:month;
            day = (day.length < 2) ? '0'+day:day;
            console.log('/articles/' + year + '/' + month + '/' + day + '/');
            window.location.assign('/articles/' + year + '/' + month + '/' + day + '/');

        }
    });
}

let initSticky = function () {
    $('.ui.sticky')
        .sticky({
            context: '.three.wide.column',
            offset: $(".ui.fixed.menu").height() + 50
        });
}

let loadAllByLetter = function ( el, url ) {
    $.ajax({
        url: url,
        method: 'get',
        dataType: 'html',
        context: el,
        success: function(data, textStatus, jqXHR) {
            $(this).fadeOut(function(){
                var div = $(el).hide();
                $(div).replaceWith(data);
                $(data).fadeIn("slow").slideDown("slow", function(){
                    // console.log(el, el.offset());
                    // $(window).animate({'scrollTop':  $(el).offset().top });
                });
            });
        },
        error: function () {
            console.error('we get error !');
        }
    })
}

let initShowAll = function() {
    $("a.show-all").on("click", function(event){
        event.preventDefault();
        loadAllByLetter( $(this).parents('.ui.segment'), $(this).attr("href") );
        $(event.currentTarget).addClass("loading");
        // $(this).html("");
        // $("<img width='15' height='5'>", {src: '/assets/img/ajax-loader.gif', alt: 'Загрузка'}).appendTo(this);
    });
}

let initScrollTo = function() {
    $(".scroll-to").on("click", function(event){
        event.preventDefault();
        let st = $($(event.currentTarget).attr("href")).offset().top;
        console.log($($(event.currentTarget).attr("href")), st);
        st -= $(".ui.fixed.menu").height() + 50;
        $(document.body).animate({scrollTop: st}, 'medium');
    });
}

let initSideBar = function() {
    $('.sidebar').first()
        .sidebar('attach events', '.js-toggle')
}

let initSearch = function() {

        var themes = new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.obj.whitespace('tags'),
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          remote: {
            url: '/search/tags?table=THEME&q=%QUERY',
            wildcard: '%QUERY'
          }
        });
        var persons = new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.obj.whitespace('tags'),
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          remote: {
            url: '/search/tags?table=PERSON&q=%QUERY',
            wildcard: '%QUERY'
          }
        });
        var organizations = new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.obj.whitespace('tags'),
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          remote: {
            url: '/search/tags?table=ORGANIZATION&q=%QUERY',
            wildcard: '%QUERY'
          }
        });


    $('#search_q').typeahead({
      hint: true,
      highlight: true,
      minLength: 3,
      classNames: {
        menu: 'tt-dropdown-menu'
      }
    },
    {
      name: 'themes',
      display: 'tags',
      source: themes,
      limit: Infinity,
      templates: {
        header: '<h2 class="ui header">Темы</h2>',
        suggestion: Handlebars.compile('<p><a href="/themes/{{alias}}">{{name}}</a></p>')
      }
    },
    {
      name: 'persons',
      display: 'tags',
      source: persons,
      limit: Infinity,
      templates: {
        header: '<h2 class="ui header">Персоны</h2>',
        suggestion: Handlebars.compile('<p><a href="/persons/{{alias}}">{{name}}</a></p>')
      }
    },
    {
      name: 'organizations',
      display: 'tags',
      source: organizations,
      limit: Infinity,
      templates: {
        header: '<h2 class="ui header">Организации</h2>',
        suggestion: Handlebars.compile('<p><a href="/organizations/{{alias}}">{{name}}</a></p>')
      }
    });
}

$(document).ready(function () {
    calendarInit();
    searchInit();
    initCalendar();
    initSticky();
    initShowAll();
    initScrollTo();
    initSearch();
    initSideBar();
});

